import { render, staticRenderFns } from "./interv-mobile-data.vue?vue&type=template&id=794b576e"
import script from "./interv-mobile-data.vue?vue&type=script&lang=js"
export * from "./interv-mobile-data.vue?vue&type=script&lang=js"
import style0 from "./interv-mobile-data.vue?vue&type=style&index=0&id=794b576e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports